import React, { useEffect, useState } from 'react';
import whatsAppIcon from '../../../img/whatsapp.svg'
import './whatsappButton.css';
import { useParametrosActivos } from '../../../hooks/Front/formularios/useFormularios';

const WhatsAppButton = ({ visible, btnXL }) => {

    const { parametros: footer, loading, error } = useParametrosActivos('FOOTER');
    const [whatsapp, setWhatsapp] = useState(undefined);

    useEffect(() => {
        if (footer) {
            setWhatsapp(footer.find((item) => item.Etiqueta === "WHATSAPP"))
        }
    }, [footer])

    return (
        whatsapp?.Valor && !loading ?
        <a href={`https://api.whatsapp.com/send?phone=${whatsapp?.Valor}`} target='_blank' rel='noreferrer'>
            <button className={`${btnXL === false ? "whatsappBtn whatsappBtnXL rounded-circle" : "whatsappBtn rounded-circle"}`} style={{ display: visible ? 'flex' : 'none' }}>
                <p className='bold-title-hyundai mb-0'>¡Contáctanos!</p>
                <img src={whatsAppIcon} alt="whatsapp-icon" />
            </button>
        </a>
        : 
        <></>
        
    );
}

export default WhatsAppButton;